import { useMemo } from "react";
import { CredentialsClient } from "@/features/credentials/api/credentials-client";

export function useCredentialsClient() {
  return useMemo(() => new CredentialsClient(), []);
}
